import { ethers } from "ethers";
import ContractDetails from "../Contracts/ContractDetails";
import { Data } from "./Data";

export default async function getContractData(id) {
  try {
    // Connect to an Ethereum node using a JSON-RPC provider
    const provider = new ethers.providers.JsonRpcProvider(
      Data.providerLink
    );

    // Get a signer from the provider
    const signer = provider.getSigner(id);

    // Create the contract instance
    const contractInstance = new ethers.Contract(
      ContractDetails.contract,
      ContractDetails.contractABI,
      signer
    );

    // Fetch contract data
    const userData = await contractInstance.users(id);
    const userMined = await contractInstance.userMined(id);
    const userClaimed = await contractInstance.userClaimed(id);
    const allUserStakes = await contractInstance.getUserStakes(id);
    const liveRate = await contractInstance.liveRate();
    const totalStaking = await contractInstance.totalStaking();
    const totalUsers = await contractInstance.totalUsers();

    // Assemble the data object
    const data = {
      userData: userData,
      userMined: userMined,
      userClaimed: userClaimed,
      liveRate: liveRate,
      totalStaking: totalStaking,
      totalUsers: totalUsers,
      allUserStakes: allUserStakes,
    };

    Data.isDebug && console.log("Contract data:", data);
    return data;
  } catch (error) {
    console.error("Error fetching contract data:", error);
    throw error; // Rethrow the error to be caught by the caller
  }
}

// Function to get REGISTER_FEE from contract using TON API
export const getRegisterFeeFromContract = async (contractAddress) => {
  try {
    // Method 1: Using TON API to call getter
    const response = await fetch(`https://toncenter.com/api/v2/runGetMethod`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        address: contractAddress,
        method: 'REGISTER_FEE',
        stack: []
      })
    });

    const data = await response.json();

    if (data.ok && data.result && data.result.stack) {
      // Parse the result - it should be a number in nanoTON
      const feeInNano = parseInt(data.result.stack[0][1]);
      const feeInTon = (feeInNano / 1_000_000_000).toFixed(9); // Convert to TON
      return feeInTon;
    }

    throw new Error('Failed to get register fee from contract');
  } catch (error) {
    console.error('Error getting register fee:', error);
    return '0.32'; // Default fallback
  }
};

// Alternative method using TON HTTP API
export const getRegisterFeeViaHTTP = async (contractAddress) => {
  try {
    const response = await fetch(`https://toncenter.com/api/v2/getContractState?address=${contractAddress}`);
    const data = await response.json();

    if (data.ok && data.result) {
      // You might need to parse the contract state to extract the fee
      // This depends on how your contract stores the fee
      return data.result;
    }
  } catch (error) {
    console.error('Error getting contract state:', error);
  }
};

// Function to convert TON to nanoTON
export const tonToNano = (tonAmount) => {
  return Math.floor(parseFloat(tonAmount) * 1_000_000_000);
};

// Function to convert nanoTON to TON
export const nanoToTon = (nanoAmount) => {
  return (parseInt(nanoAmount) / 1_000_000_000).toFixed(9);
};
